<template>
  <b-container>
    <b-modal
      ref="modal-change-password"
      header-bg-variant="dark"
      header-text-variant="light"
      title="Trocar senha"
      hide-footer
      no-close-on-backdrop
    >
      <b-card>
        <sp-form @onSubmit="onSubmit">
          <sp-form-input
            label="Informe a senha atual *"
            type="password"
            rules="required|min:4"
            v-model="form.senha"
          />
          <sp-form-input
            label="Informe a nova senha *"
            type="password"
            rules="required|min:6"
            v-model="form.novaSenha"
          />
          <sp-form-input
            label="Repita a nova senha *"
            type="password"
            rules="required|min:6"
            v-model="form.repitaNovaSenha"
            @input="clearErroMessage"
          />
          <label class="nonMatchingPasswords" v-if="nonMatchingPasswords">
            A
            <b>nova senha</b> e <b>sua confirmação</b> não sao iguais
          </label>
          <sp-button type="submit" class="btn-block mt-3" :disabled="loading" :loading="loading">
            <i class="fas fa-check"></i> Confirmar
          </sp-button>
        </sp-form>
      </b-card>
    </b-modal>
  </b-container>
</template>

<script>
import { loginService } from '@/services';

export default {
  data() {
    return {
      loading: false,
      nonMatchingPasswords: false,
      confirmedPassword: null,
      form: loginService.getChangePasswordBlankForm(),
    };
  },
  methods: {
    show() {
      this.nonMatchingPasswords = false;
      this.form = loginService.getChangePasswordBlankForm();
      this.$refs['modal-change-password'].show();
    },
    hide() {
      this.$refs['modal-change-password'].hide();
    },
    async onSubmit() {
      const { novaSenha, repitaNovaSenha } = this.form;
      if (novaSenha !== repitaNovaSenha) {
        this.nonMatchingPasswords = true;
        return;
      }
      this.loading = true;
      try {
        await loginService.changePassword(this.form);
        this.$alertify.success('Senha alterada com sucesso');
        this.hide();
      } catch (error) {
        this.$alertify.error('Erro ao alterar a senha');
      } finally {
        this.loading = false;
      }
    },
    clearErroMessage() {
      this.nonMatchingPasswords = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.nonMatchingPasswords {
  color: red;
  font-size: 13px;
}
</style>
